import { render, staticRenderFns } from "./AddNewTournament.vue?vue&type=template&id=56779cbb&scoped=true"
import script from "./AddNewTournament.vue?vue&type=script&lang=js"
export * from "./AddNewTournament.vue?vue&type=script&lang=js"
import style0 from "./AddNewTournament.vue?vue&type=style&index=0&id=56779cbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56779cbb",
  null
  
)

export default component.exports